import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=c8efa7b4&scoped=true"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"
import style0 from "./Ad.vue?vue&type=style&index=0&id=c8efa7b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8efa7b4",
  null
  
)

export default component.exports